import React from 'react';
import T from 'prop-types';

import { Container, StyledSignupButton, StyledLoginButton } from './style';

const SignupLoginButtons = ({ mobileDrawer, onClick }) => (
  <Container data-cy="nav-login-buttons" mobileDrawer={mobileDrawer}>
    <StyledLoginButton callback={onClick} ghost={mobileDrawer} mobileDrawer={mobileDrawer} />
    <StyledSignupButton callback={onClick} ghost={mobileDrawer} mobileDrawer={mobileDrawer} />
  </Container>
);

SignupLoginButtons.propTypes = {
  mobileDrawer: T.bool,
  onClick: T.func,
};

SignupLoginButtons.defaultProps = {
  mobileDrawer: false,
  onClick: () => {},
};

export default SignupLoginButtons;
